/*------------------------------------------------------------------
Import modules
------------------------------------------------------------------*/

import AccordionController from 'accordions';
import VideoEmbedController from 'scripts/marmalade/classes/video-embed';

/*------------------------------------------------------------------
Document Setup
------------------------------------------------------------------*/

// Create a new watcher
const VideoWatcher = new Watcher();

// Whenever the page content changes, check for new videos to set up
VideoWatcher.on('update', blocks => {
  // console.log('update', blocks);
  // Loop through all the blocks
  blocks.forEach(block => {
    // See if the block has already been initialized
    const initialized = block.getAttribute('data-video-watcher') === 'true';
    // Find the video media element
    const media = block.querySelector('.js-video__media');
    // Find the video transcript element
    const transcript = block.querySelector('.js-video__transcript');
    // The play button
    const play = block.querySelector('.js-video__play');

    // If the block has already been initialized, return
    if (initialized) return;
    // If there is no media element, return
    if (!media) return;

    // Set the block as initialized
    block.setAttribute('data-video-watcher', 'true');
    const URL = media.getAttribute('data-video');
    const Video = new VideoEmbedController(URL);
    const Accordion = new AccordionController(block);
    const load = () => media.appendChild(Video.iframe);
    media.addEventListener('click', e => e.preventDefault());
    media.addEventListener('click', load);

    // Create a new accordion to hold the transcript
    if (transcript) {
      Accordion.add(transcript);

      // Find the button in the transcript
      const transcriptButton = transcript.firstElementChild;
      // Find the equalizer parent
      let equalizerParent = transcript;
      let equalizerID = '';
      let searching = true;
      while (searching && equalizerParent) {
        equalizerParent = equalizerParent.parentElement;
        if (!equalizerParent) return searching = false;

        // Set the equalizer ID to the parent's ID
        equalizerID = equalizerParent.getAttribute('data-equalize-watch');

        // Check if the parent has the data-equalizer-watch attribute
        if (equalizerID !== null) {
          // Stop searching
          searching = false;
        }
      }
      if (!equalizerID) return;
      transcriptButton.addEventListener('click', e => {
        e.preventDefault();
        // Remove the height style from the equalizer parent
        equalizerParent.style.height = '';
        setTimeout(() => {
          window.equalizers[equalizerID].update();
        }, 400);
      });

      // Accordion.on('open', () => {
      //   window.equalizers[equalizerID].update();
      // });

      // Accordion.on('close', () => {
      //   window.equalizers[equalizerID].update();
      // });
    }
  });
});

// Watch for new videos on the page
VideoWatcher.watch('.js-video');